import { Navigate, useLocation, useParams } from 'react-router-dom';

const BILLING_TABS = ['invoices', 'reminders'];
const PAYROLL_TABS = ['payslips', 'history', 'stats'];

/**
 * The old « Paie & Factures » address (/payslipManagement/…), kept for
 * bookmarks: each tab goes to its page, « Facturation » or « Paie », with the
 * month of its URL.
 */
const LegacyPayslipManagementRedirect = () => {
  const { '*': rest = '' } = useParams();
  const { search } = useLocation();
  const [tab] = rest.split('/');
  let target = '/payroll/payslips';
  if (BILLING_TABS.includes(tab)) target = `/billing/${tab}`;
  else if (PAYROLL_TABS.includes(tab)) target = `/payroll/${tab}`;
  return <Navigate to={`${target}${search}`} replace />;
};

export default LegacyPayslipManagementRedirect;
